import { PropsWithChildren } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import styles from './signed-in.module.css';

export function Screen({ children }: PropsWithChildren) {
  return (
    <div className={styles.screen}>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
